module.exports = require("@swa-ui/core/src/Icon/Icon.module.scss");